import { useEquipmentResourceStore } from './useEquipmentResourceStore'

/** Store-backed Equipment Resource records and save command. */
export default function useEquipmentResources({
  projectId,
}: {
  projectId?: string
}) {
  const { records, loading, isReady, schema, save, store } =
    useEquipmentResourceStore(projectId)

  return {
    records,
    loading,
    isReady,
    schema,
    save,
    controlCommands: store.controls,
  }
}
